import { Banner } from '@/app/entities/Banner'
import { Dialog, DialogClose, DialogContent } from '../ui/dialog'
import { cn } from '@/app/utils/cn'
import { getYoutubeEmbedUrl } from '@/view/pages/Conteudos/components/TrainingView'
import { withCdn } from '@/app/utils/withCdn'
import { Button } from '../ui/button'
import { useState } from 'react'
import { Checkbox } from '../ui/checkbox'
import { localStorageKeys } from '@/app/config/localStorageKeys'

import { Logo } from '../ui/logo'

interface DashboardModalProps {
  banner?: Banner
  open: boolean
  setOpen(value: boolean): void
}

export const DashboardModal = ({
  banner,
  open,
  setOpen,
}: DashboardModalProps) => {
  const [checked, setChecked] = useState(false)
  const handleOpenChange = (state: boolean) => {
    if (checked) {
      localStorage.setItem(
        localStorageKeys.DASHBOARD_MODAL,
        JSON.stringify(banner),
      )
    }
    setOpen(state)
  }
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        {/* Header */}
        <div>
          <Logo />
        </div>

        {/* Image or VideoUrl */}
        <div>
          {banner?.videoUrl ? (
            <iframe
              className={cn(
                'aspect-[350/235] h-full min-h-[265px] w-full min-w-[350px] rounded-xl',
                banner.videoUrl.includes('shorts') &&
                  'aspect-[350/624] max-h-[550px]',
              )}
              src={getYoutubeEmbedUrl(banner.videoUrl)}
              title={banner.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            banner?.uri && (
              <img
                src={withCdn(banner.uri)}
                alt="banner-img"
                className="aspect-[350/235] w-full rounded-lg object-cover"
              />
            )
          )}
        </div>

        {/* Texts */}
        <div>
          {banner?.title && <p className="text-lg font-bold">{banner.title}</p>}
          {banner?.description && (
            <p className="text-sm text-black04">{banner.description}</p>
          )}
        </div>

        {/* Button */}
        <div className="space-y-2">
          {banner?.buttonLabel && (
            <DialogClose asChild>
              <Button
                className="w-full text-lg font-bold"
                onClick={() => banner?.link && window.open(banner?.link)}
              >
                {banner.buttonLabel}
              </Button>
            </DialogClose>
          )}
          <div className="flex w-full items-center justify-center">
            <Checkbox
              id="dont-show-again"
              checked={checked}
              onCheckedChange={(v: boolean) => setChecked(v)}
            />
            <label htmlFor="dont-show-again" className="ml-2">
              Não exibir novamente
            </label>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
